import React from "react";
import { useHistory } from "react-router-dom";

import styles from "./ForgotPassword.module.scss";
import logo from "assets/img/compliancy-group-logo.png";
import Button from "components/Button/Button";

import WelcomePanel from "../components/WelcomePanel/WelcomePanel";

const ForgotPasswordSuccess = props => {
  const history = useHistory();
  return (
    <WelcomePanel type="forgot-success">
      <div className={styles["login-panel-heading"]}>
          <img className={styles.logo} src={logo} alt="" />
      </div>
      <div className={styles["login-panel-content"]}>
        <p className={styles.welcome}>We&apos;ve sent you an email!</p>
      </div>
      <div className={styles["login-panel-footer"]}>
        <Button text={"BACK TO LOGIN"} onClick={() => history.push('/login')} />
      </div>
    </WelcomePanel>
  );
};

export default ForgotPasswordSuccess;
